<template>
    <div class="search_link clearfix">
        <ul class="clearfix">
            <MyTab
                :li_class="link_01"
                url="/"
                label_ja="すべて"
                label_en="All Databases"
            />
            <MyTab
                :li_class="link_02"
                url="/search/article/paper"
                label_ja="論文"
                label_en="Research Papers"
            />
            <!-- <MyTab
                :li_class="link_06"
                url="/search/image/hinshu"
                label_ja="認定品種"
                label_en="Major New Varieties"
            /> -->
            <MyTab
                :li_class="link_07"
                url="/search/image/noukigu"
                label_ja="農機具"
                label_en="Historical Farimng Tools"
            />
        </ul>
        <div class="btn_help">
            <a
                href="https://www.agropedia.affrc.go.jp/agriknowledge/help"
                target="_blank"
            >
                <div></div>
                <!-- ？画像差し込み -->
                <p>ヘルプ</p>
            </a>
        </div>
    </div>
</template>

<script>
// Tab.vueを読み込む
import MyTab from "./Tab.vue";
import { useRoute } from "vue-router";
import { defineComponent, ref } from "vue";

export default defineComponent({
    components: { MyTab },
    name: "MyTabbar",
    setup() {
        const route = useRoute();
        const link_01 = ref("link_01");
        const link_02 = ref("link_02");
        const link_06 = ref("link_06");
        const link_07 = ref("link_07");
        let matched = route.matched.filter(
            (item) => item.meta && item.meta.title
        );
        if (matched.length > 0) {
            if (matched[0].meta.dpname.startsWith("DP1")) {
                link_01.value = "link_01_current";
            } else if (matched[0].meta.dpname.startsWith("DP2")) {
                link_02.value = "link_02_current";
            } else if (matched[0].meta.dpname.startsWith("DP3")) {
                link_06.value = "link_06_current";
            } else if (matched[0].meta.dpname.startsWith("DP4")) {
                link_07.value = "link_07_current";
            }
        }

        return {
            link_01,
            link_02,
            link_06,
            link_07,
        };
    },
});
</script>

<style>
.search_link {
    font-family: "メイリオ", Meiryo, "ヒラギノ角ゴ Pro W3",
        "Hiragino Kaku Gothic Pro", "HiraKakuPro-W3", "ＭＳ Ｐゴシック",
        "MS PGothic", Arial, Helvetica, sans-serif;
    font-size: small;
    font: x-small;
    font-size: 1.4rem;
    line-height: 1.8;
    color: #000;
    border-bottom: 10px solid #188031;
}
.search_link ul {
    float: left;
    display: table;
    border-collapse: separate;
    border-spacing: 5px 0;
    margin-left: -5px;
    width: 845px;
}
.search_link li {
    width: 282px;
    display: table-cell;
    vertical-align: middle;
    border: 2px solid #188031;
    border-radius: 6px 6px 0 0;
    border-bottom: none;
    background-color: #fff;
    transition: 0.3s;
    -webkit-transition: 0.3s;
}
.link_01_current,
.link_02_current,
.link_06_current,
.link_07_current,
.btn_help {
    background-image: linear-gradient(
        180deg,
        rgb(80, 172, 103) 0%,
        rgb(24, 128, 49) 100%
    );
    /* -ms-filter:"progid:DXImageTransform.Microsoft.gradient(startColorstr=#ff439858,endColorstr=#ff188031,GradientType=0)"; */
    /* filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#ff439858,endColorstr=#ff188031,GradientType=0); */
}
.search_link li:hover {
    background-color: #f6ffd6;
}
.search_link li a {
    color: #333333;
    display: block;
    text-align: center;
    text-decoration: none;
    /*padding: 9px;*/
    padding: 4px;
}
.search_link li a:hover {
    color: #188031;
}
.search_link li a {
    color: #333333;
    display: block;
    text-align: center;
    text-decoration: none;
    /*padding: 9px;*/
    padding: 4px;
}
.search_link li span {
    display: inline-block;
    padding: 3px 0 3px 60px;
    background: no-repeat 0 center;
    background-image: none;
    background-size: auto;
    background-size: auto 40px;
    text-align: left;
    line-height: 2.5;
}
.search_link li span p + p {
    font-size: 70%;
    line-height: 1;
}
.btn_help {
    width: 100px;
    float: right;
    border-radius: 6px;
    overflow: hidden;
}
.btn_help a {
    padding: 8px 0 0 0;
    color: #fff;
    display: block;
    text-align: center;
    text-decoration: none;
}
.btn_help a:hover {
    text-decoration: none;
    color: #fff;
}
.btn_help a div {
    background-image: url("../../../../public/images/icon_help_off.png");
    background-repeat: no-repeat;
    background-position: 50% 0%;
    height: 30px;
    position: relative;
}
</style>
